import { useToast } from "./use-toast";

const variantClasses = {
  destructive: "border-red-200 bg-red-50 text-red-800",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  default: "border-slate-200 bg-white text-slate-800",
};

/**
 * Renders the toasts queued by `useToast()`. Without this mounted, every
 * `toast({...})` call is invisible (the hook only stores them in memory).
 */
export function Toaster() {
  const { toasts, dismiss } = useToast();

  if (!toasts.length) return null;

  return (
    <div className="fixed right-4 top-4 z-[9999] flex w-[min(92vw,360px)] flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`rounded-lg border p-3 shadow-lg ${
            variantClasses[t.variant] || variantClasses.default
          }`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              {t.title && <p className="m-0 text-sm font-semibold">{t.title}</p>}
              {t.description && (
                <p className="m-0 mt-0.5 break-words text-sm opacity-90">
                  {typeof t.description === "string" ? t.description : String(t.description)}
                </p>
              )}
            </div>
            <button
              type="button"
              onClick={() => dismiss(t.id)}
              className="shrink-0 text-lg leading-none opacity-60 hover:opacity-100"
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Toaster;
